import { getSignature } from '@/utility/requestHelpers/getSignature';

export const getSprdAuthHeader = async (
  method: string,
  path: string,
  apiKey: string,
  secret: string
): Promise<string> => {
  const currentTimeMillis = new Date().getTime().toString();
  const data = `${method} ${path} ${currentTimeMillis}`;
  const signature = await getSignature(`${data} ${secret}`);

  return `SprdAuth: apiKey="${apiKey}", data="${data}", sig="${signature}"`;
};
